import { transformComponent } from '@formily/antdv-x3/esm/__builtins__/shared'
import { InputProps } from 'ant-design-vue'
import { connect, mapProps, mapReadPretty } from '@formily/vue'
import { CountDownInput as Input } from '@radical/components'
import { PreviewText } from '@formily/antdv-x3'

const TransformElInput = transformComponent<InputProps>(Input, {
  change: 'input',
  autocomplete: 'autocomplete',
})

const CountDownInput = connect(
  TransformElInput,
  mapProps({ readOnly: 'read-only' }),
  mapReadPretty(PreviewText.Input),
)

export default CountDownInput
